import React from "react";
import { DriveFileRenameOutline } from "@mui/icons-material";

import { useLayerPanelContext } from "fond/project/panels/InputPanel/LayerPanelContext";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";

interface LayerDrawActionProps {
  title?: string;
  subtitle?: string;
  /** Defaults to opening the `${layerKey}-draw` screen. */
  onClick?: () => void;
}

/**
 * `LayerPanel` action for drawing the layer's data on the map.
 */
const LayerDrawAction: React.FC<LayerDrawActionProps> = ({ title = "Draw", subtitle = "Add and edit data on the map", onClick }) => {
  const { layerKey } = useLayerPanelContext();
  const { open } = useStackedNavigationContext();

  return (
    <StackedNavigationButton
      data-testid={`draw-${layerKey}-button`}
      icon={<DriveFileRenameOutline />}
      title={title}
      subtitle={subtitle}
      onClick={onClick ?? (() => open(`${layerKey}-draw`))}
    />
  );
};

export default LayerDrawAction;
